import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

// Css
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import '../node_modules/slick-carousel/slick/slick.css';
import '../node_modules/slick-carousel/slick/slick-theme.css';
import '../node_modules/magnific-popup/dist/magnific-popup.css';
import './assets/css/plugins/animate.min.css';
import './assets/fonts/flaticon/flaticon.css';
import './assets/css/plugins/font-awesome.min.css';
import './assets/css/style.css';
import './assets/css/responsive.css';
import './assets/css/message-modal.css';
import './index.css';

ReactDOM.render(
  <BrowserRouter basename={"/themes/themeforest/react/sacreva/"}>
    <App />
  </BrowserRouter>,
  document.getElementById('sacreva')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Register service worker so the site is installable and works offline after first load.
serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    window.dispatchEvent(new CustomEvent('rccg-sw-update', { detail: { registration } }));
  },
  onSuccess: () => {
    window.dispatchEvent(new Event('rccg-sw-cached'));
  }
});
